import breakpoints from '@configs/breakpoints';
import useComponentVisible from '@store/hooks/useComponentVisible';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DefaultScreen from './DefaultScreen';
import { INavigationItem } from './types';

interface IProps {
  items: INavigationItem[];
}

export default function SidebarMobile({ items }: IProps) {
  const { t } = useTranslation();

  const [isCorrectBreakpoint, setIsCorrectBreakpoint] = useState(false);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  function handler() {
    const mediaQueryList = window.matchMedia(`(min-width: ${breakpoints.laptop}px)`);
    setIsCorrectBreakpoint(!mediaQueryList.matches);
  }

  useEffect(() => {
    handler();
    window.addEventListener('resize', handler, false);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    if (!isCorrectBreakpoint) return;

    const app = document.getElementById('app')!;
    app.classList.add('ease-in-out', 'duration-300', 'transition-transform');
    if (isComponentVisible) {
      app.classList.add('translate-x-[320px]');
      app.classList.remove('translate-x-0');
    } else {
      app.classList.add('translate-x-0');
      app.classList.remove('translate-x-[320px]');
    }
  }, [isComponentVisible, isCorrectBreakpoint]);

  if (!isCorrectBreakpoint) return <></>;
  return (
    <div className="grid">
      <button
        className="h-full flex flex-col items-center justify-between text-xxs font-semibold px-1 cursor-pointer"
        role="button"
        aria-label={t('ToOpen')}
        onClick={() => setIsComponentVisible(true)}>
        <span className="icon inline-flex items-center justify-center w-6 h-6">
          <i className="fa-solid fa-bars fa-2x" />
        </span>
        <span className="font-medium">{t('Menu')}</span>
      </button>

      <div
        className={`w-full h-full fixed top-0 left-0 bg-white opacity-75 z-10 ${
          isComponentVisible ? 'block' : 'hidden'
        }`}
      />

      <div className={`fixed top-0 left-[-320px] w-[320px] h-full z-20`}>
        {isComponentVisible && (
          <DefaultScreen
            navigationItems={items}
            divRef={ref}
            onClose={() => setIsComponentVisible(false)}
          />
        )}
      </div>
    </div>
  );
}
